import { AttributeDetailEditor } from '@leverege/ui-attributes';
import PositionDetailModel from './PositionDetailModel';
import PositionDetailRenderer from './PositionDetailRenderer';
export default {
  install(molten) {
    molten.addPlugin('Model', {
      type: PositionDetailModel.TYPE,
      model: PositionDetailModel
    });
    molten.addPlugin('ModelEditor', {
      type: PositionDetailModel.TYPE,
      editor: AttributeDetailEditor
    });
    molten.addPlugin('DetailRenderer', {
      type: PositionDetailModel.TYPE,
      renderer: PositionDetailRenderer
    });
    molten.addPlugin('Detail', {
      name: 'Position and Map Link',
      objectType: 'case',
      create: () => {
        const json = PositionDetailModel.create('case.vehicle$vehicle.locator$locator.position', 'case');
        return json;
      },
      layout: {
        group: []
      }
    });
    molten.addPlugin('Detail', {
      name: 'Position and Map Link',
      objectType: 'vehicle',
      create: () => {
        const json = PositionDetailModel.create('vehicle.locator$locator.position', 'vehicle');
        return json;
      },
      layout: {
        group: []
      }
    });
    molten.addPlugin('Detail', {
      name: 'Position and Map Link',
      objectType: 'locator',
      create: () => {
        const json = PositionDetailModel.create('locator.position', 'locator');
        return json;
      },
      layout: {
        group: []
      }
    });
    molten.addPlugin('Detail', {
      name: 'Position and Map Link',
      objectType: 'case.history',
      create: () => {
        const json = PositionDetailModel.create('case.vehicle$vehicle.locator$locator.position', 'case');
        return json;
      },
      layout: {
        group: []
      }
    });
    molten.addPlugin('Detail', {
      name: 'Position and Map Link',
      objectType: 'vehicle.history',
      create: () => {
        const json = PositionDetailModel.create('vehicle.locator$locator.position', 'vehicle');
        return json;
      },
      layout: {
        group: []
      }
    });
    molten.addPlugin('Detail', {
      name: 'Position and Map Link',
      objectType: 'locator.history',
      create: () => {
        const json = PositionDetailModel.create('locator.position', 'locator');
        return json;
      },
      layout: {
        group: []
      }
    });
  }
};